module.exports = __webpack_public_path__ + "img/1_1@2x.491f9001.png";